import {
  FloatingLabel,
  InputGroup,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Controller, Control, FieldError } from "react-hook-form";

type FloatNumericProps = {
  label: string;
  name: string;
  control: Control<any>;
  errorsMessage?: FieldError | undefined;
  disabled?: boolean;
  readOnly?: boolean;
  tooltipMessage?: string;
  textAlign?: "center";
  autoComplete?: boolean;
  useFloatingLabel?: boolean;
  decimalScale?: number;
};

export const FloatNumericComponent = ({
  label,
  name,
  control,
  errorsMessage,
  disabled = false,
  readOnly = false,
  tooltipMessage = "",
  textAlign,
  autoComplete = false,
  useFloatingLabel = true,
  decimalScale = 2,
}: FloatNumericProps) => {
  const formatDecimal = (val: number | undefined | null) => {
    if (val === undefined || val === null || isNaN(val)) return "";
    return val.toLocaleString("pt-BR", {
      minimumFractionDigits: decimalScale,
      maximumFractionDigits: decimalScale,
    });
  };

  const inputElement = (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const rawValue = e.target.value;
          const cleanValue = rawValue.replace(/\D/g, "");
          if (cleanValue === "") {
            field.onChange(undefined);
            return;
          }
          const numericValue =
            Number(cleanValue) / Math.pow(10, decimalScale);
          field.onChange(numericValue);
        };

        const numericInput = (
          <Form.Control
            ref={field.ref}
            value={formatDecimal(field.value)}
            onChange={handleInputChange}
            onBlur={field.onBlur}
            placeholder={label}
            disabled={disabled}
            readOnly={readOnly}
            inputMode="numeric"
            className={textAlign === "center" ? "text-center" : ""}
            autoComplete={autoComplete ? "on" : "off"}
            isInvalid={!!errorsMessage?.message}
          />
        );

        if (tooltipMessage) {
          return (
            <OverlayTrigger
              placement="bottom-start"
              overlay={<Tooltip id={`tooltip-${name}`}>{tooltipMessage}</Tooltip>}
              trigger={["hover", "focus"]}
            >
              {numericInput}
            </OverlayTrigger>
          );
        }

        return numericInput;
      }}
    />
  );

  return (
    <InputGroup hasValidation>
      {useFloatingLabel ? (
        <FloatingLabel label={label}>
          {inputElement}
          {errorsMessage?.message && (
            <Form.Control.Feedback type="invalid">
              {errorsMessage.message.toString()}
            </Form.Control.Feedback>
          )}
        </FloatingLabel>
      ) : (
        <>
          {inputElement}
          {errorsMessage?.message && (
            <Form.Control.Feedback type="invalid">
              {errorsMessage.message.toString()}
            </Form.Control.Feedback>
          )}
        </>
      )}
    </InputGroup>
  );
};
export default FloatNumericComponent;
